<template>
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00051 16.0898C9.00051 16.0898 14.4935 14.4268 14.4935 9.84186C14.4935 5.25701 14.693 4.90163 14.252 4.45722C13.8103 4.01208 9.72126 2.58984 9.00051 2.58984C8.28051 2.58984 4.19075 4.01574 3.749 4.45722C3.308 4.89798 3.50825 5.25627 3.50825 9.84186C3.50825 14.4275 9.00051 16.0898 9.00051 16.0898Z"
      fill="#8BC34A" />
    <path
      d="M7.04883 9.09071L8.53172 10.5758L11.5865 7.51953"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
